import type { AxiosInstance } from 'axios';
import type { ContactTagsResponseDTO } from '@/modules/tags/infrastructure/dto/ContactTagsRespondeDTO';
import type { ITagsQueryParams } from '@/modules/tags/infrastructure/dto/ContactTagsDTO';

export default class ContactTagsApi {
  constructor(private readonly http: AxiosInstance) {}

  async getTags(params?: ITagsQueryParams) {
    try {
      const queryParams = this.buildQueryParams(params);
      const url = queryParams
        ? `/new-tag/tags?${queryParams}`
        : `/new-tag/tags`;
      const { data } = await this.http.get<ContactTagsResponseDTO>(url);

      return data;
    } catch (error) {
      throw new Error(error.response?.data?.message ?? error);
    }
  }

  async addTagToContact(
    contactId: number,
    agentId: number,
    tagItemId: number[],
  ) {
    try {
      const { data } = await this.http.post(
        `/new-tag/agent/contacts/${contactId}/tag-items?agentId=${agentId}`,
        {
          tag_item_ids: tagItemId,
        },
      );

      return data;
    } catch (error) {
      throw new Error(error.response?.data?.message ?? error);
    }
  }

  async addTagToEmployer(
    employerId: number,
    agentId: number,
    tagItemId: number[],
  ) {
    try {
      const { data } = await this.http.post(
        `/new-tag/agent/employers/${employerId}/tag-items?agentId=${agentId}`,
        {
          tag_item_ids: tagItemId,
        },
      );

      return data;
    } catch (error) {
      throw new Error(error.response?.data?.message ?? error);
    }
  }

  async deleteTagFromEmployer(
    employerId: number,
    agentId: number,
    tagItemId: number[],
  ) {
    try {
      const { data } = await this.http.delete(
        `/new-tag/agent/employers/${employerId}/tag-items/${tagItemId}?agentId=${agentId}`,
      );

      return data;
    } catch (error) {
      throw new Error(error.response?.data?.message ?? error);
    }
  }

  async deleteTagFromContact(
    contactId: number,
    agentId: number,
    tagItemId: number[],
  ) {
    try {
      const { data } = await this.http.delete(
        `/new-tag/agent/contacts/${contactId}/tag-items/${tagItemId}?agentId=${agentId}`,
      );

      return data;
    } catch (error) {
      throw new Error(error.response?.data?.message ?? error);
    }
  }

  private buildQueryParams(params?: ITagsQueryParams): string {
    if (!params || Object.keys(params).length === 0) {
      return '';
    }

    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        if (Array.isArray(value)) {
          searchParams.append(key, value.join(','));
        } else if (typeof value === 'boolean') {
          searchParams.append(key, value.toString());
        } else {
          searchParams.append(key, String(value));
        }
      }
    });

    return searchParams.toString();
  }
}
